module.exports = __webpack_public_path__ + "static/media/dissonanceCurves.3f7ae23d.jpg";